<template>
  <nav v-if="totalPage > 1">
    <ul class="pagination d-flex justify-content-end" :totalPage="totalPage">
      <li class="page-item" v-if="currentPage > maxItems">
        <button type="button" class="page-link" @click="$emit('changePaginate', currentPage - 1)">
          Previous
        </button>
      </li>
      <li
        class="page-item"
        :class="{ 'active': currentPage == i}"
        v-for="i in totalPage"
        v-if="i > currentPage - maxItems / 2 && i < currentPage + maxItems / 2"
        v-bind:key="i">
        <button type="button" class="page-link" @click="$emit('changePaginate', i)" :class="{ 'active': currentPage == i}">
          {{ i }}
        </button>
      </li>
      <li class="page-item" v-if="currentPage < totalPage - maxItems">
        <button type="button" class="page-link" @click="$emit('changePaginate', currentPage + 1)">
          Next
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    totalPage: {
      type: Number,
      default: () => 10
    },
    currentPage: {
      type: Number,
      default: () => 1
    },
    maxItems: {
      type: Number,
      default: () => 10
    }
  },
  components: {

  },
  computed: {

  },
  watch: {

  }
}
</script>